<div class="container">
    <div class="loading-spinner" *ngIf="loading" role="alert">
        <div class="spinner-backdrop" aria-label="Loading, please wait"></div>
        <div class="spinner">
            <div></div>
            <div></div>
        </div>
        <div class="loading-text">Loading..</div>
    </div>
    <div class="row">
        <div class="col-24">
            <h1>SOA History</h1>
        </div>
    </div>
    <div>
        <div>
            <form (keydown)="onKeyDown($event)">
                <fieldset>
                    <legend>Search for a Scope of Appointment</legend>
                    <label *ngIf="IsrecordFound" style="color:red;">{{serviceResponse}}</label>
                    <div class="row">
                        <div class="col-8">
                            <div class="input-wrapper">
                                <label for="BeneficiaryName">Beneficiary Name</label><input type="text" id="BeneficiaryName"
                                                                                            name="BeneficiaryName" [(ngModel)]="searchInsertModel.BeneficiaryName">
                            </div>
                        </div>
                        <div class="col-8">
                            <div class="input-wrapper">
                                <label for="BeneficiaryEmail">Beneficiary Email</label><input type="text" id="BeneficiaryEmail"
                                                                                              name="BeneficiaryEmail" [(ngModel)]="searchInsertModel.BeneficiaryEmail" />
                            </div>
                        </div>

                    </div>
                    <div *ngIf="showAgentID; else other_content">
                        <div class="row">
                            <div class="col-8">
                                <div class="input-wrapper">
                                    <label for="Agent ID">Agent ID</label><input type="text" id="AgentId"
                                                                                 name="AgentId" [(ngModel)]="searchInsertModel.AgentId" />
                                </div>
                            </div>
                            <div class="col-8">
                                <div class="input-wrapper wide">

                                    <label for="Agent ID">Status</label>
                                    <select [(ngModel)]="searchInsertModel.Status" id="status" name="status">
                                        <option *ngFor="let status of beneficiaryStatus" value={{status.text}}>
                                            {{status.value}}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ng-template #other_content>
                        <div class="row">
                            <div class="col-8">
                                <div class="input-wrapper wide">

                                    <label for="Agent ID">Status</label>
                                    <select [(ngModel)]="searchInsertModel.Status" id="status" name="status">
                                        <option *ngFor="let status of beneficiaryStatus" value={{status.text}}>
                                            {{status.value}}
                                        </option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </ng-template>

                    <div class="row">
                        <div class="col-10">
                            <div class="dropdown-notes">
                                <p><strong>Status Definitions</strong></p>
                                <ul>
                                    <li><strong>Signed:</strong> SOA Form is signed by beneficiary and sent back to agent</li>
                                    <li><strong>Expired:</strong> SOA link expired after two weeks</li>
                                    <li><strong>Viewed:</strong> SOA form was viewed by the beneficiary but not signed</li>
                                    <li><strong>In Progress:</strong> SOA link sent to beneficiary</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </fieldset>
                <div class="row">
                    <div class="col-24">
                        <button id="search" class="button primary" (click)="searchBSOAData(searchInsertModel)">Search</button>
                        <button id="submitSOA" class="button primary" *ngIf="showSOAButton" (click)="sendNewSOA()">Send a new SOA</button>
                    </div>
                </div>
            </form>
            <div class="row">
                <div class="col-24">
                    <button id="exportToExcel" class="button link excel" (click)="exportToExcel()">Export to Excel</button>
                </div>
            </div>
        </div>

        <div style="display:none" id="exportTable">
            <table>
                <thead>
                    <tr>
                        <th>Beneficiary Name</th>
                        <th>Beneficiary Email</th>
                        <th>Agent ID</th>
                        <th>Status</th>
                        <th>Date Created</th>
                        <th>Plan Year</th>
                        <th></th>
                    </tr>
                </thead>

                <tbody>
                    <tr *ngFor="let exp of beneficiarySOAViewModel">
                        <td>{{exp.BeneficiaryName}}</td>
                        <td>{{exp.BeneficiaryEmail}}</td>
                        <td>{{exp.AgentUserProfileName}}</td>
                        <td>{{exp.FormStatus}}</td>
                        <td>{{exp.RecCreateTS}}</td>
                        <td>{{exp.PlanYear}}</td>

                    </tr>
                </tbody>


            </table>
        </div>
        <div class="fileNotFound">{{downloadError}}</div>

        <div class="row">
            <div class="col-24">
                <jqxGrid (onCellclick)="CellclickOnEdit($event)"
                         [width]="1175"
                         [height]="630"
                         [source]="dataAdapter"
                         [columns]="columns" #gridReference
                         [pageable]="true"
                         [pagesizeoptions]="[20, 50, 100]"
                         [pagesize]="20"
                         [sortable]="true"
                         [columnsresize]="true"
                         [autoshowcolumnsmenubutton]="false"
                         [filterable]="true"
                         [enabletooltips]="true"
                         [selectionmode]="'multiplecellsadvanced'"
                         [virtualmode]="true"
                         [rendergridrows]="rendergridrows"
                         [updatefilterconditions]="updatefilterconditions"
                         [ready]="ready"
                         (onSort)="onSort($event)"
                         (onFilter)="onFilter($event)"
                         (onPagesizechanged)="onPageSizeChanged($event)">
                </jqxGrid>
            </div>
        </div>

        <!--<div class="row">
            <div class="col-24" id="viewSOAData">
                <table class="table-text-small">
                    <thead>
                        <tr>
                            <th (click)="setOrder('BeneficiaryName')"
                                [class.active]="order === 'Beneficiary Name'"
                                class="mdl-data-table__cell--non-numeric col-3" colspan="1">
                                Beneficiary Name
                                <span [hidden]="reverse">▼</span><span [hidden]="!reverse">▲</span>
                            </th>
                            <th (click)="setOrder('BeneficiaryEmail')"
                                [class.active]="order === 'Beneficiary Email'"
                                class="mdl-data-table__cell--non-numeric col-6" colspan="1">
                                Beneficiary Email
                                <span [hidden]="reverse">▼</span><span [hidden]="!reverse">▲</span>
                            </th>
                            <th (click)="setOrder('AgentId')" [class.active]="order === 'Agent ID'"
                                class="mdl-data-table__cell--non-numeric col-3" colspan="1">
                                Agent ID
                                <span [hidden]="reverse">▼</span><span [hidden]="!reverse">▲</span>
                            </th>
                            <th (click)="setOrder('FormStatus')" [class.active]="order === 'Status'"
                                class="mdl-data-table__cell--non-numeric col-3" colspan="1">
                                Status
                                <span [hidden]="reverse">▼</span><span [hidden]="!reverse">▲</span>
                            </th>
                            <th (click)="setOrder('RecCreateTS')" [class.active]="order === 'Date Created'"
                                class="mdl-data-table__cell--non-numeric col-3" colspan="1">
                                Date Created
                                <span [hidden]="reverse">▼</span><span [hidden]="!reverse">▲</span>
                            </th>
                            <th (click)="setOrder('PlanYear')" [class.active]="order === 'Plan Year'"
                                class="mdl-data-table__cell--non-numeric col-2" colspan="1">
                                Plan Year
                                <span [hidden]="reverse">▼</span><span [hidden]="!reverse">▲</span>
                            </th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let b of beneficiarySOAViewModel | orderBy: key : reverse
                                 | paginate: { itemsPerPage:20, currentPage: p }; let i = index">

                            <td>{{b.BeneficiaryName}}</td>
                            <td>{{b.BeneficiaryEmail}}</td>
                            <td>{{b.AgentUserProfileName}}</td>
                            <td>{{b.FormStatus}}</td>
                            <td>{{b.RecCreateTS | date:'MM/dd/yyyy'}}</td>
                            <td>{{b.PlanYear}}</td>
                            <td>
                                <div *ngIf="b.FormStatus=='Signed';else other_content_licenseNumber">
                                    <a class="link-button link download-pdf" (click)="downloadPDF(b)">Download</a>
                                </div>
                                <ng-template #other_content_benPDF></ng-template>
                        </tr>

                    </tbody>
                </table>

            </div>
        </div>-->
    </div>

    <!--<pagination-controls maxSize="5" directionLinks="true" (pageChange)="p = $event" autoHide="true"></pagination-controls>-->

</div>


